<template>
  <div class="container">

    <div class="content">

      <div class="top" v-if="html != ''">
        <div class="title">{{postsTitle}}</div>
        <div class="message">
          <div v-if="postsTypeAlbum != ''" style="white-space:nowrap;">公告类型：{{postsTypeAlbum}}</div>
          <div v-if="postsTypeAlbum != '需求调查' && postsTypeAlbum != '公司通知' && postsMinTitle != '无' && postsMinTitle != ''">采购编号：{{postsMinTitle}}</div>
          <div style="white-space:nowrap;">发布时间：{{postsTime}}</div>
        </div>
      </div>
      
      <div v-else class="loading">
        <i class="el-icon-loading"></i>
      </div>
      
      <div v-html="html"></div>
      
      <div class="fileList" v-if="postsFile.length > 0">
        <div class="fileListScoll">
          <div class="downloadFile" v-for="(item,index) in postsFile" :key="index">
            <div style="display:flex">          
              <svg v-if="item.file.substring(item.file.lastIndexOf('.')+1) == 'pdf'" t="1671897597284" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="22740" width="60" height="60"><path d="M661.15 72L860 261.81V952H164V72h497.15M666 0H152a60 60 0 0 0-60 60v904a60 60 0 0 0 60 60h720a60 60 0 0 0 60-60V256.67a60 60 0 0 0-18.57-43.4L707.39 16.6A60 60 0 0 0 666 0z" fill="#959CA7" p-id="22741"></path><path d="M92 555m20 0l582 0q20 0 20 20l0 276q0 20-20 20l-582 0q-20 0-20-20l0-276q0-20 20-20Z" fill="#0058a4" p-id="22742"></path><path d="M165.46 807.64V618.36h77.18q30.26 0 47.54 18t17.28 45.58q0 28-17.31 45.8t-47.78 17.78h-36.56v62.13z m40.21-92.91h21.17q19.64 0 29.75-7.5t10.1-25.3q0-15.7-8.51-24.25t-23.73-8.55h-28.78zM332.83 807.64V618.36h70.92q22.48 0 39 6.73t26.51 19.43A83.69 83.69 0 0 1 484 674.07q4.72 16.86 4.72 38.37a155.83 155.83 0 0 1-2.91 31.25 95.33 95.33 0 0 1-9.37 26.19 66.32 66.32 0 0 1-40.32 33.19 105.94 105.94 0 0 1-32.34 4.57zM373 775.19h24.82q24.41 0 37-14.27t12.55-47.65a113.91 113.91 0 0 0-2.43-24.79A62 62 0 0 0 437 669a35.87 35.87 0 0 0-15.39-13.44q-9.92-4.71-23.78-4.71H373zM518.1 807.64V618.36h122.44v32.45h-82.23v50.75h75V734h-75v73.63z" fill="#FFFFFF" p-id="22743"></path></svg>
              <svg v-if="item.file.substring(item.file.lastIndexOf('.')+1) == 'zip'" t="1672858764821" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2338" width="60" height="60"><path d="M661.15 72L860 261.81V952H164V72h497.15M666 0H152a60 60 0 0 0-60 60v904a60 60 0 0 0 60 60h720a60 60 0 0 0 60-60V256.67a60 60 0 0 0-18.57-43.4L707.39 16.6A60 60 0 0 0 666 0z" fill="#959CA7" p-id="2339"></path><path d="M92 555m20 0l582 0q20 0 20 20l0 276q0 20-20 20l-582 0q-20 0-20-20l0-276q0-20 20-20Z" fill="#0058a4" p-id="2341"></path><path d="M206.37 807.64v-25.85l89.58-129.46v-1.53h-87.37v-32.44h135.9v25.82l-89.3 129.35v1.67h92.08v32.45zM378.32 807.64V618.36h40.21v189.28zM457.64 807.64V618.36h77.18q30.26 0 47.54 18t17.28 45.58q0 28-17.31 45.8t-47.78 17.78H498v62.13z m40.21-92.91H519q19.64 0 29.75-7.5t10.1-25.3q0-15.7-8.51-24.25t-23.73-8.55h-28.76z" fill="#FFFFFF" p-id="2342"></path></svg>
              <svg v-if="item.file.substring(item.file.lastIndexOf('.')+1) != 'pdf' && item.file.substring(item.file.lastIndexOf('.')+1) != 'zip'" t="1672857880290" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="1683" width="60" height="60"><path d="M661.15 72L860 261.81V952H164V72h497.15M666 0H152a60 60 0 0 0-60 60v904a60 60 0 0 0 60 60h720a60 60 0 0 0 60-60V256.67a60 60 0 0 0-18.57-43.4L707.39 16.6A60 60 0 0 0 666 0z" fill="#959CA7" p-id="1684"></path><path d="M92 555m20 0l582 0q20 0 20 20l0 276q0 20-20 20l-582 0q-20 0-20-20l0-276q0-20 20-20Z" fill="#0058a4" p-id="1686"></path><path d="M142.43 807.64V618.36h70.92q22.49 0 39 6.73t26.51 19.43a83.71 83.71 0 0 1 14.71 29.56q4.72 16.86 4.72 38.37a155.83 155.83 0 0 1-2.91 31.25 95.33 95.33 0 0 1-9.38 26.18 66.32 66.32 0 0 1-40.32 33.19 105.94 105.94 0 0 1-32.34 4.57z m40.21-32.45h24.82q24.4 0 37-14.27T257 713.28a113.91 113.91 0 0 0-2.43-24.79 62 62 0 0 0-7.9-19.53 35.87 35.87 0 0 0-15.39-13.44q-9.92-4.71-23.78-4.71h-24.85zM320.07 725.41v-23.57q0-40.49 21.91-63.79t60.32-23.3q38.48 0 60.22 23.37t21.73 63.72v23.57q0 40.08-21.8 63T402 811.25q-38.55 0-60.25-22.88t-21.68-62.96z m40.77 0.2q0 25.63 11.23 39t30.1 13.39q18.86 0 30.09-13.37t11.23-39V701.5q0-25.77-11.3-39.62t-30-13.85q-18.72 0-30 13.92t-11.3 39.55zM508.25 723.89v-21.36q0-41.46 21.22-64.62t58.94-23.16a89 89 0 0 1 31.42 5.34 68 68 0 0 1 23.74 14.49 65.31 65.31 0 0 1 20 47.29v4h-38.42q0-15.42-9.71-26.29t-26.76-10.87q-18.44 0-29.05 13.74T549 702.71V724q0 26.51 10.54 39.91T589 777.27q17.19 0 26.69-10.11t9.5-25.39h38.41v4.16a61.13 61.13 0 0 1-5.12 24.75A65.2 65.2 0 0 1 644 791.49q-9.34 9.08-23.81 14.42a91.56 91.56 0 0 1-31.91 5.34q-37.86 0-58.94-23t-21.09-64.36z" fill="#FFFFFF" p-id="1687"></path></svg>
              
              <div style="margin:0px 30px 0px 15px">
                <div>{{item.file.substring(item.file.lastIndexOf('/')+1,item.file.lastIndexOf('.'))}}</div>
                <div style="font-size:14px">{{item.uploadDate.substring(0,10)}}</div>
              </div>
            </div>

            <a :href="item.file" target="_blank" >
              <svg t="1671897797798" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="23752" width="30" height="30"><path d="M328 576h152V128h64v448h152L512 768 328 576z m568-64h-64v320H192V512h-64v384h768V512z" p-id="23753" fill="#0058a4"></path></svg>
            </a>

          </div>
        </div>
      </div>
      
      

    </div>

  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "Detail",
  data() {
    return {
      html:'',
      postsId:"",
      postsTitle:"",
      postsMinTitle:"",
      postsType:"",
      postsTypeAlbum:"",
      postsTime:"",

      postsFile:[],
      loading:true,
    };
  },
  mounted(){
    this.postsId = this.$route.query.postsId
    this.getPostsDetail(this.postsId)
  },
  methods: {
    getPostsDetail(postsId){
      this.loading = true
      var url = this.GLOBAL.URL+"/getPostsDetail/"+postsId
      axios.get(url).then((response) => {
        console.log(response.data)

        this.html = response.data.detail[0].postsContent
        this.postsTitle = response.data.posts[0].postsTitle
        this.postsMinTitle = response.data.posts[0].postsMinTitle
        this.postsType = response.data.posts[0].postsType
        this.postsTypeAlbum = response.data.posts[0].postsTypeAlbum
        this.postsTime = response.data.posts[0].postsTime

        this.postsFile = response.data.postsFile

        // this.gallery = response.data.detail[0].postsGallery

        // var recommendPosts = response.data.recommendPosts
        // this.recommendPosts = recommendPosts.filter((data) => data.postsId != postsId)

        this.loading = false
      },
      (error) => {
        console.log(error.message);
      });
    },


  },
  watch: {
   $route: {
     handler() {
        var postsId = this.$route.query.postsId;
        this.html = ''
        window.scrollTo(0, 0)
        this.getPostsDetail(postsId)
     },
     deep: true,
   },
 },

  computed: {

  },
};
</script>

<style scoped>
.container {
  min-width: 1300px;
  max-width:1920px;
  margin:0px auto;
}
.content{
  padding: 40px 190px 20px 190px;
}
.top{
  border-bottom:#d3d3d3 1px dashed;
}
.title{
  display: flex;
  justify-content: center;
  font-size: 22px;
  font-weight: 600;
}
.message{
  display: flex;
  justify-content: center;
}
.message div{
  font-size: 14px;
  margin: 10px;
}
.loading{
  width: 100%;
  display: flex;
  justify-content: center;
  font-size: 50px;
  margin-top: 280px;
  color: #7f7f7f;
}

.fileList{
  width: 100%;
  overflow: hidden;
  border-radius: 20px;
  background-color: #f7f7f7;
}
.fileListScoll{
  display: flex;
  overflow-y: hidden;
  border-radius: 20px;
  padding: 0px 0px 0px 10px;
  /* margin-top: 6px; */
}
.downloadFile{
  height: 100px;
  background-color: #ffffff;
  border-radius: 10px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0px 20px 0px 20px;
  margin:10px 10px 10px 0px;
  color: #6d6d6d;
  font-size: 20px;
  font-weight: 400;
  white-space: nowrap;
  user-select: none;
  position: relative;
  box-shadow: 0px 0px 10px 0px rgba(92, 92, 92, 0.15);
}


::v-deep table{
  border-spacing: 0px;
  border:0.5px solid;
}
::v-deep td{
  border:0.5px solid;
}
::v-deep a{
  text-decoration: none;
  color: brown;
}
::v-deep .video-container {
  position:relative;
  overflow:hidden;
  padding-top:56.25%;
}
::v-deep .video-container iframe {
  position:absolute;
  top:0;
  left:0;
  width:100%;
  height:100%;
  border:0;
}
::v-deep [data-w-e-type="video"]{
  position:relative;
  overflow:hidden;
  padding-top:56.25%;
}
::v-deep [data-w-e-type="video"] iframe{
  position:absolute;
  top:0;
  left:0;
  width:100%;
  height:100%;
  border:0;
}
::v-deep [data-w-e-type="video"] video{
  width: 100% !important;
  margin-top:-56.25%;
}

</style>